<section class="footer border-top bg-light" *ngIf="showFullFooter">
    <div class="container-fluid px-lg-5">
        <div class="row g-4">
            <!-- Logo Section -->
            <div class="col-lg-3 text-center mb-4 d-flex align-items-center justify-content-center">
                <a href="https://lf.cktechsoln.in/">
                    <img src="../../../assets/img/new/athulya-agencies.png" alt="Logo" class="img-fluid footer-logo">
                </a>
            </div>

            <!-- Google Map Section -->
            <div class="col-lg-5 mb-4 text-center">
                <iframe class="w-100 rounded shadow-sm" height="250"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4996.561163896702!2d78.6872752!3d10.7597355!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3baa8b47212ca849%3A0x3d5ba6c1801699a!2sAthulya%20Agencies%20(%20Icecream%20and%20Frozen%20Food%20Distributor)%20Trichy!5e1!3m2!1sen!2sin!4v1776235819915!5m2!1sen!2sin"
                    width="600" height="350" style="border:0;" allowfullscreen="" loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade">
                </iframe>
            </div>

            <!-- Contact Section -->
            <div class="col-lg-4 d-lg-flex align-items-center justify-content-center">
                <div>
                    <h5 class="josefin-sans-bold text-dark mb-4 contact-us-title">Contact Us</h5>
                    <ul class="list-unstyled mt-3">
                        <li class="d-flex align-items-start mb-3">
                            <i class="bi bi-geo-alt-fill text-primary me-3 fs-5"></i>
                            <a href="https://www.google.com/maps/search/?api=1&query=64A,+jayalakshmi+nagar+2nd+street,+kk+nagar,+Trichy+-+620021"
                                target="_blank" class="text-decoration-none text-dark d-flex contact-link">
                                <span class="josefin-sans-medium fs-5">64A, jayalakshmi nagar 2nd street,<br> kk nagar,
                                    Trichy - 620021</span>
                            </a>
                        </li>
                        <li class="d-flex align-items-center mb-2">
                            <i class="bi bi-whatsapp text-success me-3 fs-5"></i>
                            <a href="https://wa.me/919087003398" target="_blank"
                                class="text-decoration-none josefin-sans-medium text-dark footer-whatsapp-link contact-link fs-5">
                                +91 90870 03398
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Footer Bottom -->
<div class="footer_bottom bg-dark text-white">
    <div class="container">
        <div class="row d-flex justify-content-between align-items-center text-center">
            <div class="col-lg-6">
                <p class="mb-0 josefin-sans-regular">&copy; <b>{{ currentYear }}</b> All rights reserved
                </p>
            </div>
            <div class="col-lg-6 justify-content-between align-items-center text-center">
                <p class="mb-0 josefin-sans-regular">Designed & Developed by
                    <a href="https://cktechsoln.in/" target="_blank"
                        class="text-white text-decoration-none josefin-sans-bold">CKTech Solution Pvt Ltd Madurai.</a>
                </p>
            </div>
        </div>
    </div>
</div>